import { Language } from '../language/languageStore.types';

export interface BaseUrlStoreType {
  language: Language;
  isYearView: boolean;
  path: string;
}

export enum BaseUrlStoreKind {
  INITIAL = 'INITIAL',
}

export interface BaseUrlStoreAction {
  type: BaseUrlStoreKind;
  payload: BaseUrlStoreType;
}

export type ReportYears =
  | {
      reportStartYear: number;
      reportEndYear: number;
    }
  | undefined;

export const defaultReportYears: ReportYears = {
  reportStartYear: 2021,
  reportEndYear: 2022,
};

export const possibleBaseUrls: BaseUrlStoreType[] = [
  {
    language: Language.DE,
    isYearView: false,
    path: 'deViewDefault',
  },
  {
    language: Language.DE,
    isYearView: true,
    path: 'deViewYears',
  },
  {
    language: Language.EN,
    isYearView: false,
    path: 'enViewDefault',
  },
  {
    language: Language.EN,
    isYearView: true,
    path: 'enViewYears',
  },
];
